import { TemplateModule } from './../template/template.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

import { WidgetsModule } from '../../widgets/widgets.module';
import { IntralinksMappingDialogComponent } from './intralinks-mapping-dialog.component';
import { AaclTreeListModule } from 'aacl-tree-list';
import { WidgetListModule } from './../widget-list/widget-list.module';
import { ComponentTypeMapper } from './../template/component-type-mapper.service';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        // kendo
        ButtonsModule,
        ChartModule,
        DateInputsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,
        AaclTreeListModule,
        TemplateModule,

        WidgetListModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        ComponentTypeMapper,
    ],
    declarations: [
        IntralinksMappingDialogComponent,
    ],
    exports: [
        IntralinksMappingDialogComponent,
    ]
})
export class IntralinksMappingDialogModule { }
